import { gql } from "@apollo/client";

export const CREATE_AVATAR_IMAGE = gql`
  mutation CreateAvatar($avatar_image_url: String!) {
    createAvatar(avatar_image_url: $avatar_image_url) {
        data {
            avatar {
                avatar_image_url
                id
            }
        }
        error {
            message
            code
            field
        }
    }
}
`;
export const DELETE_AVATAR_IMAGE = gql`
  mutation DeleteAvatar($avatar_id: UUID!) {
    deleteAvatar(avatar_id: $avatar_id) {
        error {
            message
            code
            field
        }
        data {
            message
        }
    }
}

`;